/**
 * Mixin for handling common API error scenarios
 */
export default {
    methods: {
        /**
         * Checks whether an error represents a 403 Forbidden response.
         *
         * AdminForm can emit two different error shapes depending on the HTTP status:
         *   - Axios error (HTTP 403 status)  → error.response.status === 403
         *   - Plain JSend object (HTTP 200 body with code 403) → error.code === 403
         *
         * @param {Object} error
         * @returns {boolean}
         */
        isForbiddenError(error) {
            return (error && error.response && error.response.status === 403) || (error && error.code === 403);
        },

        /**
         * Shows a flash message for an API error, without leaking the raw
         * backend message. Requires the component to also use notificationsMixin
         * (for showAlertMessage).
         *
         * @param {Object} error Error thrown by makeApiRequest, or a JSend error body
         * @param {string} forbiddenMessage Message shown when the error is a 403
         * @param {string} [genericMessage] Message shown for any other error
         */
        handleApiError(error, forbiddenMessage, genericMessage = 'Ooops, something went wrong. Please refresh and try again.') {
            if (this.isForbiddenError(error)) {
                this.showAlertMessage(forbiddenMessage, 'error');
                return;
            }
            this.showAlertMessage(genericMessage, 'error');
        },
    },
};



// WEBPACK FOOTER //
// ./src/Assets/mixins/ApiErrorMixin.js